export const AUTH_CUSTOMER = 'auth-customer';
export const GRID_ROW_DATA = 'grid-row-data';
export const FR_USER_DATA = 'fr-user-data';
export const ROLE_DATA = 'role-data';
export const CUST_USER_ROLE_PERMISSION = 'cust_user-role-permission';
export const DEVICE_TEMPERATURE = 'grid-row-data';
export const TOKEN_EXPIRED_ERROR_MESSAGE_LOGOUT = 'Oops..!! Token Expired, Customer Logout Successfully';
export const USERNAME_PASSWORD_INCORRECT = 'Username or password is incorrect';
export const USERNAME_PASSWORD_INCORRECT_MESSAGE = 'Oops..!! Username or password is incorrect';
export const COMMON_ERROR_MESSAGE_UI = 'Oops..!! Something went wrong';
export const FILE_EXISTS = 'Oops..!! File already exists';
export const FILE_SIZE_EXCEEDED = 'File size exceeds the 5 MB limit.';
export const INVALID_FILE_TYPE = 'Invalid file type. Please upload a JSON file.';
export const ERROR_FROMDATE_VALIDATION_MESSAGE = 'From date should not be greater than To date.';
export const ERROR_TODATE_VALIDATION_MESSAGE = 'To date should be greater than From date.';
export const CONTAINER_BOOKING_SUB_HEADING = 'Please select one of your container bookings below to check Container Tracking and Cargo details.';
export const NO_ALERTS_EVENTS_FOUND = 'No Alerts and Events Found';
export const NO_DND_DATA_FOUND = 'No Dnd Data Found';
export const NO_SHIPPING_FOUND = 'No Shipments Found';
export const ALERTS_EVENTS_UPDATED_SUCCESS = 'Alerts and Events updated successfully';
export const RESET_CHANGES_HEADING = 'Reset All Changes';
export const ALERT_RESET_CHANGES_MESSAGE = 'Are you sure you want to reset to default impact levels?';
export const SAVE_CHANGES_HEADING = 'Save Changes';
export const ALERT_SAVE_CHANGES_MESSAGE = 'Are you sure you want to change the impact levels?';
export const CUSTOMER_LOGOUT_SUCCESSFULLY = 'Customer Logout Successfully';
export const TYPEAHEAD_RECORD_LIMIT = 20;
export const TYPEAHEAD_FIELD_BOOKINGCONTAINER = 'BookingContainer'
export const SETTINGS_RESET_CHANGES_MESSAGE = 'Are you sure you want to reset to default DnD Free days?'
export const SETTINGS_SAVE_CHANGES_MESSAGE = 'Are you sure you want to change the number of free days for DnD calculations?'
export const THRESHOLD_RESET_CHANGES_MESSAGE = 'Are you sure you want to reset to default threshold values?'
export const THRESHOLD_SAVE_CHANGES_MESSAGE = 'Are you sure you want to change the threshold values?'
export const DND_SETTINGS_UPDATED_SUCCESS = 'DnD Free Days updated successfully';
export const TWENTY_FOUR_HOURS_DATE_FORMAT = ' 23:59:59';
export const CELSIUS_DEGREE = '°C';
export const FAHRENHEIT_DEGREE = '°F'
export const CELSIUS = 'celsius';
export const FAHRENHEIT = 'fahrenheit';
export const NOT_VALID_RANGE_CONVERSION = 'Not valid range for Fahrenheit conversion. Please select range in between -22 to 167 °F.';
export const TOOLTIP_AMBIENT_TEMP = 'Adjust your device’s temperature to ensure optimal performance and comfort. Use the slider to set your desired temperature level.';
export const GPS_MARKER_INTERVAL = 10;
export const GPS_COORDINATE_TOLERANCE = 0.0001;
export const GPS_HOVER_DELAY_MS = 200;
export const INVENTORY_FILE_UPLOAD_SUCCESS = 'Inventory file is uploaded and it is processing';
export const TERMS_DECLINE_MESSAGE = 'Dry container monitoring is a pilot feature offering experimental insights based on raw device data. Acceptance is required before it can be used.';
export const TERMS_LOAD_ERROR = 'Unable to load the Terms and Conditions. Please try again later.';
export const TERMS_STATUS_ERROR = 'Unable to verify acceptance status. Please try again later.';
export const TERMS_ACCEPT_ERROR = 'Unable to save your acceptance. Please try again later.';
export const RBAC_STATE = 'rbac-state';
export const SYNC_ACCESS_CUSTOMER_NOT_AVAILABLE = 'Selected customer is not available in your access token.';